/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GuidIdCodeAndLabel,
    GuidIdCodeAndLabelFromJSON,
    GuidIdCodeAndLabelFromJSONTyped,
    GuidIdCodeAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface GuidIdCodeAndLabelAutocompleteResult
 */
export interface GuidIdCodeAndLabelAutocompleteResult {
    /**
     * 
     * @type {Array<GuidIdCodeAndLabel>}
     * @memberof GuidIdCodeAndLabelAutocompleteResult
     */
    results?: Array<GuidIdCodeAndLabel> | null;
    /**
     * 
     * @type {number}
     * @memberof GuidIdCodeAndLabelAutocompleteResult
     */
    numberOfItems?: number;
}

export function GuidIdCodeAndLabelAutocompleteResultFromJSON(json: any): GuidIdCodeAndLabelAutocompleteResult {
    return GuidIdCodeAndLabelAutocompleteResultFromJSONTyped(json, false);
}

export function GuidIdCodeAndLabelAutocompleteResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): GuidIdCodeAndLabelAutocompleteResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(GuidIdCodeAndLabelFromJSON)),
        'numberOfItems': !exists(json, 'numberOfItems') ? undefined : json['numberOfItems'],
    };
}

export function GuidIdCodeAndLabelAutocompleteResultToJSON(value?: GuidIdCodeAndLabelAutocompleteResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(GuidIdCodeAndLabelToJSON)),
        'numberOfItems': value.numberOfItems,
    };
}


